module.exports = __webpack_public_path__ + "static/media/19.e614cf6c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/19.svg
// module id = 391
// module chunks = 14